import React from 'react'
import { connect } from 'react-redux'

import {
  updatePaymentRecord,
  selectPaymentOption
} from '../actions'

import OptionListItemRadio from './OptionListItemRadio'
import CheckoutSection from './CheckoutSection'

import { hiddenAnchorStyle } from './styles'
import { Fade } from '../componentAnimations'

const getById = (methods, id) => {
  return methods.filter(pm => pm.Id === id)[0];
}

class CheckoutPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCollapsed: false }
    this.onItemSelected = this.onItemSelected.bind(this)
    this.onClickChange = this.onClickChange.bind(this)
    this.onPaymentIsValid = this.onPaymentIsValid.bind(this)
  }
  
  onPaymentIsValid() {
    this.setState({ isCollapsed: true });
  }

  onItemSelected(id) {
    const paymentOption = getById(this.props.paymentOptions, id);
    if (!paymentOption) {
      console.error(`No payment method with id '${id}'`);
      return;
    }
    if (!paymentOption.paymentOptionComponent) {
      this.setState({ isCollapsed: true });
    }
    this.props.onSelected(id, paymentOption.Name);
  }

  onClickChange(e) {
    e.preventDefault();
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  render() {
    const items = this.props.paymentOptions.map(pm => {
      let selected = pm.Id === this.props.selectedPaymentOptionId;
      if (pm.paymentOptionComponent) {
        const PaymentOptionComponent = pm.paymentOptionComponent;

        return (
            <OptionListItemRadio
              key={pm.Id}
              id={pm.Id}
              isSelected={selected}
              onClick={this.onItemSelected}
                label={pm.Name}>
                <div className='col-12' style={{ zIndex: 0 }}>
                <PaymentOptionComponent
                  isSelected={selected}
                  onPaymentIsValid={this.onPaymentIsValid}
                  onPaymentCancel={this.props.onCancel}
                />
              </div>
            </OptionListItemRadio>
          )
      } else {
        return (<OptionListItemRadio
                   key={pm.Id}
                   id={pm.Id}
                   isSelected={selected}
                   onClick={this.onItemSelected}
                   label={pm.Name} />)
      }
    });
    const canChange = true;
    return (
      <CheckoutSection label={"Payment Information"} hidden={false}>
        <div style={{ lineHeight: 2 }}>
          <a
            href=""
            style={hiddenAnchorStyle}
            onClick={(e) => this.onClickChange(e)}
          >
            {this.props.selectedDisplay || <em>Select Payment Method</em>}
            {canChange &&
                <span style={{ marginLeft: 20, color: '#004AF4', fontWeight: '600' }}>
                {this.state.isCollapsed ? 'Change' : 'Done'}
              </span>}
          </a>
        </div>
        <Fade inProp={!this.state.isCollapsed}>
          <div style={{ display: this.state.isCollapsed ? 'none' : 'inherit' }}>
            {items}
          </div>
        </Fade>
      </CheckoutSection>
    );
  }
}

const mapCheckoutPaymentStateToProps = (state) => {
  return {
    paymentOptions: state.entities.PaymentOptions,
    selectedPaymentOptionId: state.entities.SelectedPaymentOptionId,
    selectedDisplay: state.ui.selectedPaymentLabel
  }
}

const mapCheckoutPaymentDispatchToProps = (dispatch) => {
  return {
    onSelected: (id, displayName) => dispatch(selectPaymentOption(id, displayName)),
    onCancel: () => dispatch(selectPaymentOption(''))
  }
}

const CheckoutPaymentContainer = connect(
  mapCheckoutPaymentStateToProps,
  mapCheckoutPaymentDispatchToProps
)(CheckoutPayment);


export default CheckoutPaymentContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/components/CheckoutPayment.jsx